module.exports = __webpack_public_path__ + "static/img/phone.215663cd.png";